import * as React from 'react';
import { ButtonBase } from '@mui/material';
import { useTheme } from '../../../../theme';
import { useIsMobile } from '../../../../utils';
import { CdnIcon } from '@shared/ui';
import DocumentFormFields from '../DocumentFormFields/DocumentFormFields';
const DocumentFieldsItem = ({ id, traveller, primaryCountryCodes, validators, onRemove, onClear }) => {
    const { DocumentFieldsItem: css } = useTheme('TravellerForm');
    const isMobile = useIsMobile();
    const variant = isMobile ? 'underline' : 'labelIn';
    return (React.createElement("div", { className: css.documentFieldsItem },
        React.createElement(DocumentFormFields, { index: id, validators: validators, traveller: traveller, primaryCountryCodes: primaryCountryCodes, variant: variant, layout: isMobile ? 'stack' : 'grid' }),
        (onRemove || onClear) && (React.createElement("div", { className: css.documentFieldsItem__controls },
            React.createElement(ButtonBase, { classes: { root: css.buttonRemove }, onClick: () => (onRemove ? onRemove(id) : onClear === null || onClear === void 0 ? void 0 : onClear(id)) },
                React.createElement(CdnIcon, { icon: 'Action/Close-Clear' }))))));
};
export default DocumentFieldsItem;
